/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';

import StatusBadge from './StatusBadge';
import { ONBOARDING_STATUS, ONBOARDING_STATUS_LABEL } from '../constants';

// Status do onboarding de admissão (read-only — a UI dispara ações e o backend
// muda o estado). Compartilhado entre a página de onboarding e o card-resumo
// da ficha do candidato. Ver constants.ONBOARDING_STATUS.
const ONBOARDING_STATUS_VARIANT = {
   [ONBOARDING_STATUS.BACKGROUND_CHECK]: 'blue',
   [ONBOARDING_STATUS.COLETA_DOCS]: 'blue',
   [ONBOARDING_STATUS.PRE_CADASTRO]: 'blue',
   [ONBOARDING_STATUS.EXAME_ADMISSIONAL]: 'blue',
   [ONBOARDING_STATUS.RASCUNHO_ONVIO]: 'blue',
   [ONBOARDING_STATUS.ENVIO_CONTABILIDADE]: 'blue',
   [ONBOARDING_STATUS.AGUARDANDO_INICIO]: 'amber',
   [ONBOARDING_STATUS.ADMITIDO]: 'green',
   [ONBOARDING_STATUS.DESQUALIFICADO]: 'red',
};

export default function OnboardingStatusBadge({ value }) {
   return (
      <StatusBadge variant={ONBOARDING_STATUS_VARIANT[value] ?? 'neutral'}>
         {ONBOARDING_STATUS_LABEL[value] ?? value ?? '—'}
      </StatusBadge>
   );
}

OnboardingStatusBadge.propTypes = {
   value: PropTypes.string,
};
